import React from 'react';
import Datetime from 'react-datetime';
import moment from 'moment';
import Chart from 'react-chartjs-2';
import classnames from 'classnames';
import 'chartjs-plugin-datalabels';

import DateRangeIcon from '@material-ui/icons/DateRange';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from 'assets/jss/material-dashboard-pro-react/views/chartsStyle.js';
import CardFooter from 'components/Card/CardFooter';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import ReportChartLegend from './ReportChartLegend';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

class ReportChart extends React.Component {
	state = {
		anchorEl: null,
	};

	handleClick = ({ currentTarget }) => {
		this.setState({ anchorEl: currentTarget });
	}

	handleClose = () => {
		this.setState({ anchorEl: null });
	}

	render() {
		const {
			classes,
			showPeriodRange,
			title,
			headerIcon,
			chartData,
			loading,
			chartType = 'line',
			setDateRangeToReport,
			dateFrom,
			dateTo,
			downloadCsv,
			downloadPdf,
			disabled,
		} = this.props;

		const loadingIndicator = loading && <div className={classes.loadingIndicator}><LoadingIndicator /></div>
		return (
			<Card className={classes.wrapper}>
				<CardHeader color="info" icon>
					<div className={classnames({ [classes.disableChartIcon]: disabled })}>
						{headerIcon}
					</div>
					<h4
						className={classnames(
							classes.cardIconTitle,
							{ [classes.cardIconTitleDisabled]: disabled },
						)}
					>
						{title}
					</h4>
					{loadingIndicator}
				</CardHeader>
				<CardBody className={classes.cardBody}>
					{
						chartData.hasData === true
							? <Chart
								type={chartType}
								{...chartData}
							/>
							: <div className={classes.emptyDataMessage}>There is no data for selected period</div>
					}
				</CardBody>
				{chartData.hasData === true
					&& chartData.customLegend
					&& <ReportChartLegend customLegend={chartData.customLegend} />}
				<CardFooter className={classes.cardFooter}>
					<GridContainer>
						{
							showPeriodRange && (<>
								<GridItem xs={6} sm={4} md={4}>
									<InputLabel className={classes.datePickerLabel}>From</InputLabel>
									<FormControl fullWidth>
										<div className={classnames(
											classes.datetimeWrapper,
											{ [classes.datetimeWrapperDisabled]: disabled },
										)}>
											<DateRangeIcon className={classes.datetimeIcon} />
											<Datetime
												isValidDate={({ _d }) => {
													if (new Date() < _d) {
														return false;
													} else if (dateTo < _d) {
														return false;
													}
													return true;
												}}
												inputProps={{ readOnly: true, disabled }}
												timeFormat={false}
												dateFormat="MM/DD/yyyy"
												onChange={({ _d }) => setDateRangeToReport('from', _d)}
												value={dateFrom}
											/>
										</div>
									</FormControl>
								</GridItem>
								<GridItem xs={6} sm={4} md={4}>
									<InputLabel className={classes.datePickerLabel}>To</InputLabel>
									<FormControl fullWidth>
										<div className={classnames(
											classes.datetimeWrapper,
											{ [classes.datetimeWrapperDisabled]: disabled },
										)}>
											<DateRangeIcon className={classes.datetimeIcon} />
											<Datetime
												isValidDate={({ _d }) => {
													if (new Date() < _d) {
														return false;
													} else if (moment(dateFrom).startOf('day') > _d) {
														return false;
													}
													return true;
												}}
												inputProps={{ readOnly: true, disabled }}
												dateFormat="MM/DD/yyyy"
												timeFormat={false}
												onChange={({ _d }) => setDateRangeToReport('to', _d)}
												value={dateTo}
											/>

										</div>
									</FormControl>
								</GridItem>
							</>)
						}
						<GridItem
							xs={12}
							sm={showPeriodRange ? 4 : 12}
							md={showPeriodRange ? 4 : 12}
						>
							<GridContainer
								container
								display="flex"
								direction="row"
								justify="flex-end"
								alignItems="center"
							>
								<Button
									color="success"
									className={classes.downloadButton}
									fullWidth
									round
									disabled={disabled}
									aria-controls="simple-menu"
									aria-haspopup="true"
									onClick={this.handleClick}
								>
									Download
									<ArrowDropDownIcon className={classes.buttonIcon} />
								</Button>
								<Menu
									getContentAnchorEl={null}
									anchorOrigin={{
										vertical: 'bottom',
										horizontal: 'center',
									}}
									transformOrigin={{
										vertical: 'top',
										horizontal: 'center',
									}}
									anchorEl={this.state.anchorEl}
									keepMounted
									open={Boolean(this.state.anchorEl)}
									onClose={this.handleClose}
								>
									<MenuItem
										onClick={() => {
											downloadCsv();
											this.handleClose();
										}}
										className={classes.menuItem}
									>
										CSV
									</MenuItem>
									<MenuItem
										onClick={() => {
											downloadPdf();
											this.handleClose();
										}}
										className={classes.menuItem}
									>
										PDF
									</MenuItem>
								</Menu>
							</GridContainer>
						</GridItem>
					</GridContainer>
				</CardFooter>
			</Card>
		)
	}
}
export default withStyles(styles)(ReportChart);

